export const applyPercentage = (amount, percentage) => {
  return Math.round(amount * percentage) / 100;
};
